import { Icon, IconButton, Tooltip, useDisclosure } from "@chakra-ui/react";
import { usePermissions } from "contexts";
import { QuestionMarkCircle } from "icons";
import { Button } from "shared";
import Faq from "..";

type FaqButtonProps = {
  abbreviated?: boolean;
};

const FaqButton = ({ abbreviated }: FaqButtonProps) => {
  const { scope } = usePermissions();

  const faqDisclosure = useDisclosure();

  return (
    <>
      {scope("faq").isAccessible && (
        <Button
          color="blue"
          bgColor="white"
          borderRadius="40px"
          display="flex"
          justifyContent="center"
          gap={2}
          m="auto"
          my={4}
          onClick={faqDisclosure.onOpen}
          _hover={{ bgColor: "white" }}
        >
          <Icon as={QuestionMarkCircle} w="20px" h="20px" />
          {abbreviated ? "FAQ" : "Frequently Asked Questions"}
        </Button>
      )}
      <Faq {...faqDisclosure} />
    </>
  );
};

const FaqIconButton = () => {
  const { scope } = usePermissions();
  const disclosure = useDisclosure();

  if (!scope("faq").isAccessible) return null;

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    e.preventDefault();
    disclosure.onOpen();
  };

  return (
    <>
      <Tooltip label="Frequently Asked Questions" placement="bottom" hasArrow>
        <IconButton
          aria-label="Open FAQ"
          size="sm"
          variant="ghost"
          borderRadius="full"
          onClick={handleClick}
          icon={
            <Icon as={QuestionMarkCircle} color="#007AFF" w="24px" h="24px" />
          }
        />
      </Tooltip>
      <Faq {...disclosure} />
    </>
  );
};

export { FaqButton, FaqIconButton };
